<template>
    <div class="record">
        <div class="placeholder"></div>
        <div class="record-content record-warp">
            <div class="record-title">
                <span @click="$router.back()">

                    <img src="../../assets/img/wallet/arrow.png" alt="">

                    {{ $t('record.title') }}
                </span>

            </div>
            <div class="record-empty" v-if="isEmpty">
                <img src="../../assets/img/mining/empty.png" alt="">
                <div> {{ $t('record.empty') }}~</div>
            </div>
            <div v-else class="record-list">
                <div class="record-list-item" v-for="(item,i) in pagelist" :key="i">
                    <img src="../../assets/img/wallet/icon.png" alt="">
                    <div>
                        <div class="record-list-item-t">
                            <div>
                                {{ getAccountType(item.AccountType) }}
                            </div>
                            <div>{{item.AAmount}}</div>
                        </div>

                        <div class="record-list-item-b">
                            <div>
                                {{ $t('record.time') }} {{formatTime(item.AddTime)}}

                            </div>
                            <div> {{ item.BusinessMark}}</div>
                        </div>
                    </div>

                </div>



                
                <div class="me-page">
                <img src="../../assets/img/me/arrow-l.png" alt="">
                <div @click="prevPage()">{{$t('me.home')}}</div>



                <div class="page">
                    <!-- <div>01</div>
                    <div class="active" >02</div>
                    <div>03</div>
                    <div>04</div>
                    <div>05</div> -->
                </div>
                <div @click="nextPage()">{{$t('me.last')}}</div>
                <img src="../../assets/img/me/arrow-r.png" alt="">
            </div>
            </div>
        </div>

    </div>
</template>

<script>
import {
    Field,
    Swipe,
    SwipeItem,
    Circle,
    Tab,
    Tabs,
    Popup,
    Progress,
    Button,
} from "vant";
import { copyToClipboard } from "@/utils";
import NumberScroll from "@/components/NumberScroll.vue";
import SplitText from "@/components/SplitText/SplitText.vue";
import ShinyText from "@/components/ShinyText/ShinyText.vue";
import AnimatedContent from "@/components/AnimatedContent/AnimatedContent.vue";
import FadeContent from "@/components/FadeContent/FadeContent.vue";

import axios from 'axios'
import contractaa from '../contract/index.js'

export default {
    name: "record",
    components: {
        SplitText,
        ShinyText,
        AnimatedContent,
        FadeContent,
        Field,
        Swipe,
        SwipeItem,
        Tab,
        VanCircle: Circle,
        Tabs,
        Popup,
        Progress,
        Button,
        NumberScroll,
    },
    data() {
        return {
            value: "1",
            show: false,
            value1: '100',
            value2: '134.5',
            value3: '134.5',
            isEmpty: false,
            currentPage:1,
            pagelist:[]
        };
    },
    computed: {},
    
    methods: {
        getInfo(page){
            let that = this;
            let _token = this.$store.state.loginToken
            _token = encodeURIComponent(_token)
            axios.post(contractaa.APIURL+'?cmd=getfundlog','token='+ _token+'&page='+page).then(function (response) {
            if (response.status === 200) {
                    if(response.data.Status){
                        that.pagelist = response.data.Data
                    }

                }
            })
        },
        formatTime(timeStr){
            let clean = timeStr.replace('T',' ').slice(0, -4)
            return clean
        },
        getAccountType(v){
            if(v=='BN'){
                return '资金钱包'
            }else if(v=='BTC'){
                return '收益钱包'
            }else if(v=='BCH'){
                return '配置钱包'
            }
        },
        nextPage(){
            this.currentPage = this.currentPage+1;
            this.getInfo(this.currentPage)
        },
        prevPage(){
            if(this.currentPage>1){
                this.currentPage = this.currentPage-1;
                this.getInfo(this.currentPage)
            }
        }
    },
    mounted() {
        let timer = setInterval(async () => {
            if (true) {
                this.getInfo(1)
                clearInterval(timer)
            }
        }, 500);
    },
};
</script>

<style lang="less" scoped>
.record {
    position: relative;

    .placeholder {
        // height: 50px;
    }

    .record-warp {
        padding: 0 20px;
    }

    &-content {
        margin-top: 15px;
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        color: #FFFFFF;
    }

    &-title {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        color: #FFFFFF;

        >span {
            display: flex;
            align-items: center;

            >img {
                height: 16px;
                width: 16px;
                margin-right: 5px;
            }
        }


    }

    &-list {
        margin-top: 15px;

        &-item {
            margin-top: 10px;
            min-height: 70px;
            background: #1B1C1E;
            border-radius: 16px;
            padding: 16px 15px;
            display: flex;

            >img {
                width: 40px;
                height: 40px;
                margin-right: 10px;
            }

            >div {
                flex: 1;
            }

            &-t {
                display: flex;
                justify-content: space-between;
                color: #FFFFFF;
                font-size: 14px;
                font-weight: 500;
                line-height: 20px;

                >div {
                    display: flex;

                }

                span {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 10px;
                    font-size: 10px;
                    line-height: 12px;
                    margin-left: 6px;
                    padding: 3px 5px;
                    font-weight: 400;

                    i {
                        margin-right: 3px;
                        display: block;
                        height: 4px;
                        width: 4px;
                        background: #FF523F;
                        border-radius: 50%;
                        ;
                    }

                    &.red {
                        color: #FF523F;
                        background: rgba(255, 82, 63, 0.08);

                        i {
                            background: #FF523F;

                        }

                    }

                    &.green {
                        color: #78E0A4;
                        background: rgba(120, 224, 164, 0.08);

                        i {
                            background: #78E0A4;

                        }
                    }
                }

            }

            &-b {
                margin-top: 4px;
                display: flex;
                justify-content: space-between;

                color: #838383;
                font-size: 10px;
                line-height: 14px;
            }
        }
    }

    &-empty {
        margin-top: 220px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #838383;
        font-size: 14px;
        line-height: 20px;
        flex-direction: column;

        img {
            width: 84px;
            height: 84px;
        }
    }



}
.me-page {
        display: flex;
        align-items: center;
        color: #FFFFFF;
        font-size: 14px;
        line-height: 20px;
        margin-top: 20px;
        >img {
            width: 10px;
            height: 10px;
        }
        >img:first-child {
            margin-right: 5px;
        }
        >img:last-child {
            margin-left: 5px;
        }
        .page {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            >div {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 36px;
                height: 26px;
                border-radius: 6px;
                color: #838383;
                &.active {
        background: #FFFFFF;
        color: #1A130B;
        font-weight: 500;
                }
            }
            >div + div {
                margin-left: 8px;
            }
        }

    }
</style>
<style lang="less"></style>